export const ACCEPT_PATH = ['/', '/guide', '/blog', '/listing', '/about-us', '/404', '/500'];
export const PROTECTED_PATH = [
  '/my',
  '/shortlist',
  '/order',
  '/reservation',
  '/carts',
  '/request-room/form',
  // 무료 신청 폼도 로그인이 필요하다. 목록에 없으면 토큰 만료 시 redirect 파라미터 없이
  // 홈으로 튕겨 신청하던 자리를 잃는다(마케팅 페이지 /request-room 은 공개라 접두어로 묶지 않는다).
  '/request-room/free',
];

// 로그인만으론 부족하고 프로필(온보딩)까지 완성해야 들어갈 수 있는 경로 — 소셜 가입 직후 회원 대상

// 메타 광고 웰컴 랜딩 — 라우트 등록(AppContent)과 가입 완료 분기(SignupStep5)가 공용 참조
export const WELCOME_PATH = '/welcome';
